import type { SxProps, Theme } from '@mui/material';

export const backButtonContainer: SxProps<Theme> = {
  mt: 2,
  display: 'flex',
  justifyContent: 'center',
};
